import { useEffect } from 'react';

/**
 * Injecte dynamiquement les balises SEO (title, description, og:*)
 * à partir des données de page retournées par useCmsPage.
 *
 * Usage : useSeoMeta(page, { defaultTitle, defaultDesc });
 */
export default function useSeoMeta(page, defaults = {}) {
  useEffect(() => {
    if (!page) return;

    const title = page.meta_title || defaults.title || page.titre || 'Tech Talent Accelerator';
    const desc  = page.meta_description || defaults.desc || '';
    const img   = page.og_image || defaults.image || '';

    document.title = title;

    setMeta('name', 'description', desc);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:type', 'website');
    if (img) setMeta('property', 'og:image', img);
  }, [page]);
}

function setMeta(attr, value, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
